import { createFeatureSelector } from '@ngrx/store';
import { FeatureState } from './feature.state';


export const FEATURE_NAME = 'modal_add-edit-work-order ';

export const featureState = createFeatureSelector<FeatureState>(FEATURE_NAME);
